import React, { useEffect } from 'react';
import ReactDOM from 'react-dom';
import { Formik, Form } from 'formik';
import { SageClassnames, Modal, Frame } from '@kajabi/sage-react';
import { chatSchema } from 'common/components/CopyMagic/shared/validationSchema';
import useSubmitPromptSetNewMessages from 'common/components/CopyMagic/hooks/useSubmitPromptSetNewMessages';
import ErrorMessage from 'common/components/CopyMagic/components/ErrorMessage';
import SupportButton from 'common/components/CopyMagic/components/SupportButton';
import { useUiResourceContext } from 'common/components/CopyMagic/contexts';
import { useMessagesContext } from 'common/components/CopyMagic/contexts/MessagesContext';

import MessagesDisplay from '../MessagesDisplay';
import InputForm from '../InputForm';

import amaLogo from '../../images/amaLogoV2.png';

import './style.scss';

const SCROLLABLE_SELECTOR =
  '.copy-magic-conversation-assistant-fullscreen > .sage-modal__container > .sage-modal__content';
const noop = () => {};

const modalHeader = (
  <Frame
    align={Frame.ALIGNMENTS.CENTER_SPREAD}
    direction={Frame.DIRECTIONS.HORIZONTAL}
    width={Frame.WIDTHS.FILL}
  >
    <Frame
      align={Frame.ALIGNMENTS.CENTER_LEFT}
      direction={Frame.DIRECTIONS.HORIZONTAL}
      gap={Frame.GAPS.SM}
    >
      <img alt="Ama" src={amaLogo} arid-hidden="true" width="32px" />
      <h2 className={SageClassnames.TYPE.HEADING_5}>Ama</h2>
    </Frame>
    <SupportButton />
  </Frame>
);

const ConversationAssistantFullscreen = () => {
  const { initialValues, submitPrompt } = useSubmitPromptSetNewMessages();
  const { error } = useUiResourceContext();
  const { messages } = useMessagesContext();

  // Scroll to end when message length changes or an error occurs
  useEffect(() => {
    const scrollElement = window.document.querySelector(SCROLLABLE_SELECTOR);
    if (!scrollElement) return;
    scrollElement.scrollTop = scrollElement.scrollHeight;
  }, [messages.size, error]);

  return ReactDOM.createPortal(
    <Modal fullScreen active onExit={noop} className="copy-magic-conversation-assistant-fullscreen">
      <Modal.Header>{modalHeader}</Modal.Header>
      <Modal.Body>
        <div className="copy-magic-conversation-assistant-fullscreen__modal-body">
          <div className="copy-magic-conversation-assistant-fullscreen__modal-content-wrapper">
            <MessagesDisplay />
            <ErrorMessage />
          </div>
        </div>
      </Modal.Body>
      <Modal.Footer>
        <div className="copy-magic-conversation-assistant-fullscreen__modal-footer">
          <Formik
            initialValues={initialValues}
            onSubmit={submitPrompt}
            validationSchema={chatSchema}
            validateOnMount
            enableReinitialize
          >
            <Form className="copy-magic-conversation-assistant__form">
              <InputForm />
            </Form>
          </Formik>
        </div>
      </Modal.Footer>
    </Modal>,
    document.body,
  );
};

export default ConversationAssistantFullscreen;
